import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, CircularProgress, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { navStore } from '@mcn-platform/models';
const GlobalMessageDialog = () => {
    const { blockInput } = navStore;
    return (_jsx(Backdrop, { sx: { color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 10000 }, open: blockInput, children: _jsx(CircularProgress, { color: "inherit" }) }));
};
export default observer(GlobalMessageDialog);
//# sourceMappingURL=BlockInput.js.map